import { personRef } from "@/content/author";
import { socialImageMeta } from "@/lib/social-sharing";
import { createFileRoute, Link } from "@tanstack/react-router";
import bookCover1 from "@/assets/book-cover.webp";
import bookCover2 from "@/assets/book-cover-2.webp";
import bookCover3 from "@/assets/book-cover-3.webp";
import newBookCover from "@/assets/book-cover-space.jpg";
import { hreflangLinks } from "@/lib/seo";
import { PageIntro, WRAP, MoreLink } from "@/components/site/page";
import { THEME_DOT } from "@/components/site/theme-ui";

const CANONICAL = "https://akillisurdurulebilirlik.com/kitaplar";
const SITE = "https://akillisurdurulebilirlik.com";
const AUTHOR = personRef();

const books = [
  {
    to: "/kitaplar/hayati-yasanir-kilan-bosluktur" as const,
    cover: newBookCover,
    title: "Hayatı Yaşanır Kılan,",
    titleEm: "Boşluktur",
    year: "2026",
    datePublished: "2026-09",
    isbn: "9786258843200",
    publisher: "Destek Yayınları",
    publisherName: "Destek Yayınları" as string | null,
    schemaName: "Hayatı Yaşanır Kılan, Boşluktur",
    amazon: "https://www.amazon.com.tr/Hayat%C4%B1-Ya%C5%9Fan%C4%B1r-K%C4%B1lan-Bo%C5%9Fluktur-%C3%96zta%C5%9Fk%C4%B1n/dp/6258843204",
    summary:
      "Her şeyi verimlilik hesabına bağlayan çağda ölçünün dışında kalması gerekenleri; güveni, muhakemeyi, anlamı ve birlikte geçirilen zamanı savunan yeni kitap.",
    cta: "Yeni kitabı incele",
    dot: THEME_DOT.meaning,
    highlight: true,
  },
  {
    to: "/kitaplar/yalnizlik-as" as const,
    cover: bookCover3,
    title: "Yalnızlık",
    titleEm: "A.Ş.",
    year: "2026",
    datePublished: "2026-06",
    isbn: "B0H59HPG62",
    publisher: "Ücretsiz PDF — Üyelere Özel",
    publisherName: null as string | null,
    schemaName: "Yalnızlık A.Ş.",
    amazon: "https://www.amazon.com/dp/B0H59HPG62",
    summary:
      "Yalnızlık nasıl en kârlı sektör haline geldi? Arda Öztaşkın'ın yeni kitabı. Kitabın tam PDF'ini ücretsiz indirebilirsiniz — indirmek için önce siteye üye olmanız gerekir.",
    cta: "Yalnızlık A.Ş.'yi oku & PDF indir",
    dot: THEME_DOT.economy,
    highlight: false,
  },
  {
    to: "/kitaplar/yapay-zeka-gucun-iki-yuzu" as const,
    cover: bookCover1,
    title: "Yapay Zekâ:",
    titleEm: "Gücün İki Yüzü",
    year: "2024",
    datePublished: "2024",
    isbn: "B0H58HHS3B",
    publisher: "Destek Yayınları",
    publisherName: "Destek Yayınları" as string | null,
    schemaName: "Yapay Zekâ: Gücün İki Yüzü",
    amazon: "https://www.amazon.com/dp/B0H58HHS3B",
    summary:
      "Yapay zekânın yükselişini umut ve risk ekseninde okuyan bir saha rehberi. Teknolojinin gündelik hayata, iş dünyasına ve topluma etkilerini sade bir dille ele alıyor; bireylerin ve kurumların nasıl hazırlanması gerektiğine dair pratik bir çerçeve sunuyor.",
    cta: "Yapay zekâ kitabını incele",
    dot: THEME_DOT.tech,
    highlight: false,
  },
  {
    to: "/kitaplar/iklim-degil-insanlik-krizi" as const,
    cover: bookCover2,
    title: "İklim Değil,",
    titleEm: "İnsanlık Krizi",
    year: "2023",
    datePublished: "2023",
    isbn: "B0H598BYTV",
    publisher: "Yeni İnsan Yayınevi",
    publisherName: "Yeni İnsan Yayınevi" as string | null,
    schemaName: "İklim Değil, İnsanlık Krizi",
    amazon: "https://www.amazon.com/dp/B0H598BYTV",
    summary:
      "Sürdürülebilirliği insan, gezegen, ekonomi ve teknoloji boyutlarıyla okuyan bir çağrı. İklim krizinin aslında bir insanlık meselesi olduğunu, çözümün de bireysel sorumlulukta ve küçük adımlarda saklı olduğunu anlatıyor.",
    cta: "İklim krizi kitabını incele",
    dot: THEME_DOT.planet,
    highlight: false,
  },
];

const bookSchema = {
  "@context": "https://schema.org",
  "@graph": books.map((b) => ({
    "@type": "Book",
    name: b.schemaName,
    author: AUTHOR,
    isbn: b.isbn,
    datePublished: b.datePublished,
    ...(b.publisherName ? { publisher: { "@type": "Organization", name: b.publisherName } } : {}),
    url: `${SITE}${b.to}`,
    sameAs: b.amazon,
    inLanguage: "tr",
    bookFormat: "https://schema.org/Paperback",
  })),
};


export const Route = createFileRoute("/kitaplar/")({
  head: () => ({
    meta: [
      { title: "Kitaplar — Arda Öztaşkın" },
      {
        name: "description",
        content:
          "Arda Öztaşkın'ın dört kitabı: Hayatı Yaşanır Kılan Boşluktur, Yalnızlık A.Ş., Yapay Zekâ — Gücün İki Yüzü ve İklim Değil İnsanlık Krizi.",
      },
      { property: "og:title", content: "Kitaplar — Arda Öztaşkın" },
      {
        property: "og:description",
        content:
          "Dört kitap; verimlilik, yalnızlık, yapay zekâ ve sürdürülebilirlik üzerine.",
      },
      { property: "og:url", content: CANONICAL },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Kitaplar — Arda Öztaşkın" },
      { name: "twitter:description", content: "Dört kitap; verimlilik, yalnızlık, yapay zekâ ve sürdürülebilirlik üzerine." },
      ...socialImageMeta(),
    ],
    links: [
      { rel: "canonical", href: CANONICAL },
      ...hreflangLinks("/kitaplar", "/books"),
    ],
    scripts: [
      { type: "application/ld+json", children: JSON.stringify(bookSchema) },
    ],
  }),
  component: KitaplarPage,
});

function KitaplarPage() {
  return (
    <div>
      <PageIntro
        crumbs={[{ label: "Kitaplar" }]}
        kicker="Kitaplar"
        title={
          <>
            Arda Öztaşkın'ın Kitapları: <em className="italic">dört kitap, çağımızın ortak soruları</em>
          </>
        }
        lede="Verimlilik, yalnızlık, yapay zekânın yükselişi ve sürdürülebilirliğin geleceği üzerine dört kitap. Her birinin kendi sayfasında içindekiler, alıntılar, basın ve satın alma linklerini bulabilirsiniz."
      />

      <section className={`${WRAP} pb-14 lg:pb-20`}>
        <div className="flex snap-x snap-mandatory gap-5 overflow-x-auto pb-2 lg:grid lg:grid-cols-4 lg:gap-8 lg:overflow-visible lg:pb-0">
          {books.map((b) => (
            <article key={b.to} className="shrink-0 basis-[70%] snap-start space-y-4 lg:basis-auto">
              <Link
                to={b.to}
                className="block w-full overflow-hidden bg-ink/5 aspect-[2/3] shadow-sm"
                aria-label={`${b.title} ${b.titleEm} — detay sayfasına git`}
              >
                <img
                  src={b.cover}
                  alt={`${b.title} ${b.titleEm} kitap kapağı`}
                  width={280}
                  height={420}
                  loading="lazy"
                  decoding="async"
                  className="h-full w-full object-cover transition-transform duration-500 hover:scale-[1.03]"
                />
              </Link>

              <div className="space-y-2">
                <div className="flex flex-wrap items-center gap-2 text-[11px] text-ink/60">
                  <span aria-hidden className={`size-2 rounded-full ${b.dot}`} />
                  <span>{b.year}</span>
                  <span aria-hidden>·</span>
                  <span>{b.publisher}</span>
                </div>

                <h2 className="font-serif text-xl leading-tight">
                  <Link to={b.to} className="hover:text-clay transition-colors">
                    {b.title} <em className="italic">{b.titleEm}</em>
                  </Link>
                </h2>

                <p className="text-sm leading-relaxed text-ink/75 line-clamp-2">{b.summary}</p>

                <MoreLink to={b.to}>{b.cta}</MoreLink>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
